export default __webpack_public_path__ + "static/media/lottery.624828e9.svg";